export default "__VITE_ASSET__DSDSFbd5__"